import { RedeemSubDetails } from "../../model";
import apiService from "../ApiService";

export declare type VerifyRedeemCodeOpt = {
  redemptionCode?: string;
  organization: string;
  sessionId?: string;
};

export const verifyRedeemCode = ({
  redemptionCode,
  organization,
  sessionId,
}: VerifyRedeemCodeOpt) => {
  return apiService.get<RedeemSubDetails | Record<string, never>>({
    path: `public/partner/verify`,
    params: {
      redemptionCode,
      organization,
      sessionId,
    },
    crm: true,
  });
};
